import { PublicClientApplication, type Configuration, type SilentRequest } from '@azure/msal-browser';
import { appConfig } from '../config';
import { clearSignedOut } from './session';

export const msalConfig: Configuration = {
  auth: {
    clientId: appConfig.clientId,
    authority: `https://login.microsoftonline.com/${appConfig.tenantId}`,
    redirectUri: appConfig.redirectUri,
    postLogoutRedirectUri: appConfig.redirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    // sessionStorage keeps the token out of other tabs and disappears when the browser closes.
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const apiRequest: Pick<SilentRequest, 'scopes'> = {
  scopes: appConfig.apiScope ? [appConfig.apiScope] : [],
};

export const msalInstance = new PublicClientApplication(msalConfig);

/**
 * msal-browser v3 must be initialised before any other call, and the redirect promise must be handled
 * before React renders, otherwise the login response is lost.
 */
export async function initializeMsal(): Promise<void> {
  await msalInstance.initialize();

  const response = await msalInstance.handleRedirectPromise();
  if (response?.account) {
    msalInstance.setActiveAccount(response.account);

    // Somebody who has just signed in is not signed out, whatever the last thing they did in this tab was.
    clearSignedOut();
    return;
  }

  const accounts = msalInstance.getAllAccounts();
  if (!msalInstance.getActiveAccount() && accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }
}
